export default {
  name: 'submit-button',
  props: {
    text: {
      type: String,
      default: '保存'
    },
    bgClass: {
      type: String,
      default: 'default'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {
      this.$emit('submit');
    }
  }
};